import { render, staticRenderFns } from "./AudioGuidesFeedWidget.vue?vue&type=template&id=6528a816&"
import script from "./AudioGuidesFeedWidget.vue?vue&type=script&lang=js&"
export * from "./AudioGuidesFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6528a816')) {
      api.createRecord('6528a816', component.options)
    } else {
      api.reload('6528a816', component.options)
    }
    module.hot.accept("./AudioGuidesFeedWidget.vue?vue&type=template&id=6528a816&", function () {
      api.rerender('6528a816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/AudioGuidesFeedWidget.vue"
export default component.exports